import layout from '@/layout'

export default {
  path: '/sys',
  component: layout,
  redirect: '/sys/account',
  name: 'userApproval',
  meta: {
    title: '系统管理',
    icon: 'system'
  },
  children: [
    {
      path: '/sys/account',
      redirect: '/sys/account/approval',
      meta: {
        title: '平台账号管理',
        icon: 'people'
      },
      children: [
        {
          path: '/sys/account/approval',
          component: () => import('@/views/sys/user-approval'),
          meta: {
            title: '审批账号管理',
            icon: 'seal'
          }
        }
      ]
    }
  ]
}
